import { images } from './content'

export type ProjectImage = {
  src: string
  alt: string
}

/** Carousel #1 — moves right → left, right after the pain section. */
export const carouselOne: ProjectImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9edbc2d8-9132-4a15-ad3c-ed577d443480.jpg',
    alt: 'Robot di cartone fatto a mano con occhi di tappi di bottiglia, appoggiato sul tavolo della cucina',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f457dde1-b06e-4fb3-80d7-b66f1a878e1d.jpg',
    alt: 'Mano meccanica di cartone con snodi di cannucce, mossa da fili',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e5e00422-123f-4826-91b6-3a748c56a327.jpg',
    alt: 'Braccio robotico di cartone fatto in casa che afferra un cubetto di legno',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b2e1cb1c-bad2-4548-8f9c-e5f922bb0870.jpg',
    alt: 'Macchina da corsa di cartone con ruote di tappi, sul tavolo da pranzo',
  },
  { src: images.balloonCar, alt: 'Macchinina di cartone spinta da un palloncino verde' },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c8f2c014-cc48-46a4-addd-c4e689763350.jpg',
    alt: 'Veicolo costruito con una bottiglia di plastica e tappi colorati',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c967b255-807e-464d-837f-df97b474a2b2.jpg',
    alt: 'Camion di cartone con ruote di cartone e cassone fissato con il nastro adesivo',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/573c6bde-1f67-4733-8966-424394d3772d.jpg',
    alt: 'Lanciatore a elastico costruito con bastoncini del gelato e un cucchiaio di plastica',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/48cf802d-cc6e-46e0-a3c8-b50800f367ea.jpg',
    alt: 'Piccola catapulta fatta con bastoncini del gelato ed elastici',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/fc1dc115-ea63-4a8e-8992-7f926422d70d.jpg',
    alt: 'Semplice carrucola fatta con un rocchetto e uno spago che solleva un bicchiere di carta',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/58368e80-f0bc-49e7-ac2d-62ff5a4ce4c5.jpg',
    alt: 'Gru di cartone fatta in casa che solleva un cubetto di legno con un gancio di graffetta',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/52642b91-c61e-44da-9ce9-702b5d001f60.jpg',
    alt: 'Ponte di cartone e bastoncini messo alla prova con le macchinine',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d3d5bca9-1e5a-4979-a075-5dc17efc2cd6.jpg',
    alt: 'Percorso per biglie costruito con tubi di cartone e rampe',
  },
  { src: images.bottleRobot, alt: 'Robot costruito con bottiglie di plastica e tappi riciclati' },
  { src: images.cupRobot, alt: 'Robot fatto con un bicchiere di carta e braccia di scovolini' },
  { src: images.bottleRocket, alt: 'Razzo costruito con una bottiglia di plastica e carta dipinta' },
]

/** Carousel #2 — moves left → right, before the result section. */
export const carouselTwo: ProjectImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/69091f3d-e151-42d1-915f-a449a2e9e0a7.jpg',
    alt: 'Palloncino che si gonfia sopra una bottiglia in un semplice esperimento sulla pressione dell’aria',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f7a28ce7-158e-46b8-9d96-61d28e69a7d5.jpg',
    alt: 'Esperimento del galleggia o affonda in una ciotola di vetro',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/61d20900-ead9-4141-9b04-641501a3d21a.jpg',
    alt: 'Mini vulcano fatto in casa che erutta schiuma su un vassoio da cucina',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9ec96533-b91b-46d3-b876-dc8363009dda.jpg',
    alt: 'Bilancia costruita con un righello, dello spago e due bicchieri di carta',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ca9bf492-9f4d-4216-be0e-861ea982e1d0.jpg',
    alt: 'Robot costruito con una lattina, scatole, tappi e fil di ferro',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/0634a8a0-926b-4285-acf0-2ee71b24b349.jpg',
    alt: 'Creatura meccanica di cartone con zampe di carta che si muovono',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7045b7b9-cf2e-4ec0-82e5-c60e62be4768.jpg',
    alt: 'Carretto di cartone spinto dal vento con una vela di carta',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/dae953b2-cf5a-438e-90d3-2ead974e921f.jpg',
    alt: 'Torre alta costruita con tubi di carta arrotolata sul tavolo da pranzo',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/212af9e0-4044-4c3f-b81a-bcdfa36576b7.jpg',
    alt: 'Leva fatta con un righello e un tubo di cartone che solleva dei tappi',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/69423f1b-b255-407a-bf54-1f4407a2ad55.jpg',
    alt: 'Casetta di cartone con finestre ritagliate e dettagli disegnati a pennarello',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/072cffdb-4e03-4407-accf-d70d96e0707e.jpg',
    alt: 'Cupola costruita con cannucce di carta e snodi di plastilina',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/465d4c80-ce1d-4237-af15-cf2775a160f7.jpg',
    alt: 'Invenzione costruita con una bottiglia di plastica, tubi e tappi',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/37bc06e4-f15d-4f4f-bf22-eaab1b9d0cea.jpg',
    alt: 'Paracadute fatto in casa con un sacchetto di plastica e dello spago',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2fdd4840-9f9f-4091-ad8b-a621da11392b.jpg',
    alt: 'Bambina che modella un animaletto di plastilina accanto a una scheda stampata',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/dbaf12ef-4a47-46e0-8f1d-ecefa2560cd1.jpg',
    alt: 'Bambino che lancia un aeroplanino di carta in casa',
  },
  { src: images.spiralCandle, alt: 'Bambino che guarda una spirale di carta girare sopra due candele' },
]
